import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from "@angular/core";
import { IMedia } from "../live/live.component";
import { FirebaseServiceService } from "../firebase-service.service";
import { CatagoryServiceService } from "../catagory-service.service";
import { ArticleService } from "../service/article.service";
import { environment } from "../../environments/environment";
import { LazyImgDirective } from "../lazy-img.directive";
import { ImgFallbackDirective } from "../shared/img-fallback.directive";
import { BestImagePipe } from "../shared/best-image.pipe";
import { RouterLink } from "@angular/router";
import { SlicePipe } from "@angular/common";

@Component({
  selector: "app-new-screen-two",
  templateUrl: "./new-screen-two.component.html",
  styleUrls: ["./new-screen-two.component.css"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [LazyImgDirective, ImgFallbackDirective, BestImagePipe, RouterLink, SlicePipe]
})
export class NewScreenTwoComponent implements OnInit {
  featured: any = {};
  count: number = 0;

  public now: Date = new Date();
  conv: any;
  overall: any;
  finaldata: object[] = [];
  finaldata_cardio: object[] = [];
  finaldata_diab: object[] = [];
  finaldata_other: object[] = [];
  finaldata_oye: object[] = [];
  data_we_need: object[] = [];
  data_final: object[] = [];
  d: any;
  d1: any;
  d3: any;
  d1f_category: any;
  d2f_category: any;
  d3f_category: any;
  d1f_title: any;
  d2f_title: any;
  d3f_title: any;
  d1f_image_url: any;
  d2f_image_url: any;
  d3f_image_url: any;
  h1: string;
  h2: string;
  h3: string;
  finaldata_all: object[] = [];
  final_model: object[] = [];
  url: any;
  top_stories: any = [];
  top_storiesa: any;

  new_categs: object[] = [];

  sources: Array<Object> = [];
  d2: object;
  liveUpdatesVideo: any = [];
  private curated = false;
  constructor(
    private fbs: FirebaseServiceService,
    private Catservice: CatagoryServiceService,
    private service: ArticleService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.get_featured();
    this.get_live_updates();
    this.get_topStories();
    this.get_live_streaming();
    this.applyCuration();
    // NOTE: do NOT reset `this.sources` here. Under SSR the HTTP transfer-cache
    // replays get_live_streaming()'s response SYNCHRONOUSLY, so its subscribe
    // (which fills `sources`) runs DURING get_live_streaming() above — a reset on
    // this line would wipe it right after, and hydration then deletes the
    // server-rendered <video>. `sources` is initialised to [] at declaration.
    // this.sources.push({
    // 	src: "https://storage.googleapis.com/web-assets/Coronavirus-2020/Shashank-Joshi/Shashank-Joshi-Special-Edit-Video/Shashank%20Joshi_1.mp4", type: "video/mp4"
    // });
  }

  get_live_streaming() {
    this.service
      .get_article({ main_category: "tv", is_home_video: true, limit: 1 })
      .subscribe(data => {
        // Editor curation wins the race: if the overlay already set the video,
        // don't overwrite with the auto pick (either resolve-order → curated wins).
        if (this.curated) { this.cdr.markForCheck(); return; }
        if (data["success"]) {
          this.liveUpdatesVideo = data["data"][0];
          this.sources = new Array<Object>();
          this.sources.push({
            src: this.liveUpdatesVideo["video_url"],
            type: "video/mp4"
          });
        }
        this.cdr.markForCheck();
      });
  }

  // Editor-curation overlay (SSR-safe: override-with-guard, no reset-then-fill).
  // On empty/error the auto pick from get_live_streaming() stays → zero regression.
  applyCuration() {
    this.service.getPageLayoutCached("homepage").subscribe(
      (res: any) => {
        const sections = (res && res.data && res.data.sections) || [];
        const sec = sections.find((s: any) => s && s.key === "live");
        if (sec && Array.isArray(sec.articles) && sec.articles.length) {
          this.liveUpdatesVideo = sec.articles[0];
          this.sources = new Array<Object>();
          this.sources.push({
            src: this.liveUpdatesVideo["video_url"],
            type: "video/mp4"
          });
          this.curated = true;
        }
        this.cdr.markForCheck();
      },
      () => {}
    );
  }

  get_topStories() {
    this.service
      .get_article({ is_top_story: true, limit: 6 })
      .subscribe(data => {
        if (data["success"]) {
          this.top_storiesa = data["data"];
        }
        this.cdr.markForCheck();
      });
  }

  get_live_updates() {
    this.Catservice.get_live_category02().subscribe(data => {
      var data2 = data["data"];
      for (var i = 0; i < data2.length; i++) {
        this.new_categs.push(data2[i]);
      }

      // console.log("new categsssss",this.new_categs);
      for (var i = 0; i < this.new_categs.length; i++) {
        if (this.new_categs[i]["category"] == "overall") {
          // alert("aaaa")
          this.overall = true;
          continue;
        }
        // alert(this.count)
        if (this.count < 3) {
          if (this.new_categs[i]["category"] == "coronavirus") {
            this.count++;
            this.fbs.onGetUsersDocuments().subscribe(response => {
              // console.log("In Function Data")
              const data = response as object[];
              this.conv = data;
              let islive1 = false;
              for (var j = 0; j < data.length; j++) {
                this.finaldata_all.push(data[j]);
                // console.log("AAAAAAAA",data[j]['f_category']);
                // alert("AAAAAAAA"+this.finaldata_all);

                if (data[j]["is_home_live"] == "Yes") {
                  islive1 = true;
                  this.finaldata.push(data[j]);
                }
              }
              // console.log(this.finaldata_all);
              // console.log("final data",this.finaldata);

              // this.d1 = this.finaldata_all[this.finaldata_all.length - 2];
              // console.log("NewScreenTwoComponent -> ngOnInit -> this.d1", this.d1)

              this.d3 = this.finaldata[this.finaldata.length - 1];

              // this.d1f_category='/'+this.d1['f_category'].toLowerCase()+'/live-updates';
              // this.d1f_title=this.d1['f_title'];
              // this.d1f_image_url=this.d1['f_image_url'];
              // this.d2f_category='/'+this.d2['f_category'].toLowerCase()+'/live-updates';
              // this.d2f_title=this.d2['f_title'];
              // this.d2f_image_url=this.d2['f_image_url']
              if (this.d3) {
                this.d3f_category =
                  "/" + this.d3["f_category"].toLowerCase() + "/live-updates";
                this.d3f_title = this.d3["f_title"];
                this.d3f_image_url = this.d3["f_image_url"];
                var model = {
                  category: this.d3f_category,
                  title: this.d3f_title,
                  image: this.d3f_image_url
                };
                this.final_model.push(model);
              }

              if (islive1 == false) {
                this.d = this.finaldata_all[data.length - 1];
                // console.log("I CAN SEE EEEEEEEEE", this.d);
              } else {
                this.d = this.finaldata[this.finaldata.length - 1];
              }
              if (this.finaldata_other.length == 0) {
                for (
                  let i = this.finaldata_oye.length - 1;
                  i > this.finaldata_oye.length - 3;
                  i--
                ) {
                  if (i >= 0) this.data_we_need.push(this.finaldata_oye[i]);
                }
              } else if (this.finaldata_other.length == 1) {
                if (this.finaldata_oye.length > 0)
                  this.data_we_need.push(
                    this.finaldata_oye[this.finaldata_oye.length - 1]
                  );
              } else if (this.finaldata_other.length > 1) {
                for (
                  let i = this.finaldata_other.length - 1;
                  i > this.finaldata_other.length - 3;
                  i--
                ) {
                  if (i >= 0) this.data_we_need.push(this.finaldata_other[i]);
                }
              }

              if (
                this.data_we_need.length >= 2 &&
                this.data_we_need[0] &&
                this.data_we_need[1]
              ) {
                if (
                  this.data_we_need[0]["f_category"] ==
                  this.data_we_need[1]["f_category"]
                ) {
                  for (let i = this.finaldata_oye.length - 1; i > 0; i--) {
                    if (
                      this.data_we_need[0]["f_category"] !=
                      this.finaldata_oye[i]["f_category"]
                    ) {
                      this.data_we_need[1] = this.finaldata_oye[i];
                      break;
                    }
                  }
                }
                this.data_final.push(
                  this.data_we_need[this.data_we_need.length - 1]
                );
                this.data_final.push(
                  this.data_we_need[this.data_we_need.length - 2]
                );
                // console.log("ATTT", this.data_final)
                this.h2 = this.data_we_need[0]["f_category"].toLowerCase();
                this.h3 =
                  "https://therightdoctors.com/" +
                  this.data_we_need[1]["f_category"].toLowerCase() +
                  "/live-updates";
              }
              if (this.d) {
                this.h1 = this.d["f_category"].toLowerCase();
              }

              // console.log("AASSAS", this.finaldata_all[2]['f_category']);

              // console.log('datafinal', this.conv);
              // console.log('datafinalfj ', this.finaldata);
              this.cdr.markForCheck();
            });
          } else if (this.new_categs[i]["category"] == "cardiology") {
            this.count++;
            this.fbs.onGetUsersDocuments2().subscribe(response => {
              // console.log("In Function Data")
              const data = response as object[];
              this.conv = data;
              let islive1 = false;
              for (var j = 0; j < data.length; j++) {
                this.finaldata_all.push(data[j]);
                if (data[j]["is_home_live"] == "Yes") {
                  this.finaldata_cardio.push(data[j]);
                }
              }

              // console.log("final data cardio",this.finaldata_cardio);

              this.d2 = this.finaldata_cardio[this.finaldata_cardio.length - 1];

              if (this.d2) {
                this.d2f_category =
                  "/" + this.d2["f_category"].toLowerCase() + "/live-updates";
                this.d2f_title = this.d2["f_title"];
                this.d2f_image_url = this.d2["f_image_url"];
                var model = {
                  category: this.d2f_category,
                  title: this.d2f_title,
                  image: this.d2f_image_url
                };
                this.final_model.push(model);
              }
              this.cdr.markForCheck();
            });
          } else if (this.new_categs[i]["category"] == "diabetes") {
            this.count++;
            this.fbs.onGetUsersDocuments3().subscribe(response => {
              // console.log("In Function Data")
              const data = response as object[];
              this.conv = data;
              let islive1 = false;
              for (var j = 0; j < data.length; j++) {
                if (data[j]["is_home_live"] == "Yes") {
                  this.finaldata_diab.push(data[j]);
                }
              }

              // console.log("final data diabetes",this.finaldata_diab);

              this.d1 = this.finaldata_diab[this.finaldata_diab.length - 1];

              if (this.d1) {
                this.d1f_category =
                  "/" + this.d1["f_category"].toLowerCase() + "/live-updates";
                this.d1f_title = this.d1["f_title"];
                this.d1f_image_url = this.d1["f_image_url"];
                var model = {
                  category: this.d1f_category,
                  title: this.d1f_title,
                  image: this.d1f_image_url
                };
                this.final_model.push(model);
              }
              this.cdr.markForCheck();
            });
          } else {
            this.count++;
            var finaldata_diab = [];
            this.fbs
              .onGetUsersDocuments4(this.new_categs[i]["key"])
              .subscribe(data => {
                this.conv = data;
                let islive1 = false;
                for (var j = 0; j < data.length; j++) {
                  if (data[j]["is_home_live"] == "Yes") {
                    finaldata_diab.push(data[j]);
                  }
                }

                // console.log("final data new categories",finaldata_diab);

                this.d1 = finaldata_diab[finaldata_diab.length - 1];

                if (this.d1) {
                  this.d1f_category =
                    "/" + this.d1["f_category"] + "/live-updates";
                  this.d1f_title = this.d1["f_title"];
                  this.d1f_image_url = this.d1["f_image_url"];
                  var model = {
                    category: this.d1f_category,
                    title: this.d1f_title,
                    image: this.d1f_image_url
                  };
                  this.final_model.push(model);
                }
                this.cdr.markForCheck();
              });
          }
        }
      }
      this.cdr.markForCheck();
    });
    console.log("final_model: ", this.final_model);
  }

  get_featured() {
    this.service
      .get_article({
        category: "cme",
        blog_category: "feature",
        is_exclusive: false,
        limit: 1
      })
      .subscribe(data => {
        if (data["success"]) {
          this.featured = data["data"][0];
          this.featured["href_link"] = this.buildHrefLink(this.featured);
        }
        this.cdr.markForCheck();
      });
  }

  buildHrefLink(story: any) {
    if (!story) return "";
    let href_link = environment.frontend_url;
    switch (story["main_category"]) {
      case "insights":
        href_link += `insights/${story["category"]}/${story["blog_category"]}/`;
        break;
      case "podcast":
        href_link += `podcast/${story["event"]}/`;
        break;
      default:
        href_link += `tv/${story["event"]}/${story["category"]}/`;
    }
    return href_link + story["slug"];
  }
}
